


















import { Vue, Component } from 'vue-property-decorator'
import { Scroller } from '@lx-frontend/cvux'
import CouponItem from './components/couponItem.vue'
import CodeDialog from './components/dialog.vue'
@Component({
  components: {
    Scroller,
    CouponItem,
    CodeDialog
  }
})
export default class Index extends Vue {
  showDialog = false

  pullConfig = {
    content: '',
    downContent: '',
    upContent: '',
    loadingContent: '加载中...'
  }

  queryForm = {
    page: 1,
    count: 10
  }

  currentItem = {}

  totalCount = 0
  totalPage = 0
  list: Object[] = []

  async mounted() {
    this.queryForm = {
      page: 1,
      count: 10
    }
    const { code, data } = await this.$rest.coupon.getQRCodeList(this.queryForm)
    if (code === 0) {
      const { count } = this.queryForm
      this.totalCount = data.total_num
      this.totalPage = Math.floor((this.totalCount + count - 1) / count)
      this.list = data.coupon_batch_groups
    }
  }

  handleOpenCode(card: object) {
    this.showDialog = true
    this.currentItem = card
  }

  async loadMore(done: Function) {
    if (this.queryForm.page < this.totalPage) {
      this.queryForm.page++
      const { code, data } = await this.$rest.coupon.getQRCodeList(this.queryForm)
      if (code === 0) {
        const { count } = this.queryForm
        this.totalCount = data.total_num
        this.totalPage = Math.floor((this.totalCount + count - 1) / count)
        this.list.push(...data.coupon_batch_groups)
        done(100)
      }
    } else {
      done()
    }
  }
}
